import enLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
      txtWelcom: 'Welcome to',
      txtIndexName: '首页',
      txtWorkBenchName: '个人工作台',
      txtHelp:'帮助',
      txtNotifyName: '通知公告',
      txtPersonTips: '个人提醒',
      txtUncomplete: '代办事项',
      txtCompleted: '已办事项',
      txtViewMore: '查看更多',
      txtQuickMap: '快捷导航',
      txtPublishTime: '发布时间',
      txtLogoutName: '退出登录',
      txtWebSite: '三一智慧监审平台',
      txtWebSiteEn: 'SANY Smart Audit Platform',
      copyRight:
            "<p>集团公司 版权所有 Copyright 1996-2020 sany.com.cn</p>",
      enLocale,


      language:'中文',
      noLanguage:'English',

      jbts:'举报投诉',
      ljrz:'廉洁认证',
      lplj:'礼品礼金',
      lyct:'利益冲突',
      ljsj:'廉洁上缴',
      ljsy:'廉洁三一',
      jbjlbz:'举报奖励标准',
      jbfscx:'举报方式查询',
      hxqd:'红线清单',
      dlsb:'登录失败！请联系应用管理员 田辉阳(tianhy16)',
      dl:'廉洁三一 登录',
      sy:'首页',

      scz:'上传中...',
      scsb:'上传失败',
      wj:'文件',
      qsctpgswj:'请上传图片格式文件',
      jg:'警告',
      scwj:'请确认是否删除文件，删除后将不可还原',
      shangchuanchenggong:'上传成功',
			shanchuchenggong:'删除成功',
			csnbbm:'内部部门',
			csqymc:'企业名称',
			csqxzbm:'请选择部门',
			csqtxqymc:'请填写企业名称',
			csxydm:'信用代码',
			cstxqymchdjsszddc:'填写企业名称后点击搜索自动带出',
			sbljcns:'廉洁承诺书',
			sbljcns1:'本人知悉公司已制定利益冲突管理制度，该制度明确了利益冲突的基本情形和相应的处理措施。',
			sbljcns2:'为确保我在履行公司赋予的职务时的透明性，现本人申报存在或可能引起利益冲突的情况如下：',
			sbwjs:'我接受',
			tx:'提醒',
			btc:'不填充',
			tc:'填充',
			s:'是',
			f:'否',
			tctx:'检测到您在 {date} 有 {type} 数据，您需要填充到当前的申报数据上吗？',
			tempSb:'申报',
			tempZc:'暂存',

			sbItemTitle1:'经办企业',
			sbItemQuest1:'1、您是否以个人名义或通过他人，以独立或合资方式，或以承包、租赁等模式<span class="font_bold">从事商业活动或创办企业</span>？',
			sbItemTitle2:'亲属经办企业与公司利益冲突',
			sbItemQuest2:'2、您的直系亲属（包括配偶、子女、以及您和配偶的父母）是否以个人名义或与他人合资的方式<span class="color_red">（含通过控股公司、代持股份等间接方式）</span><span class="font_bold">从事商业活动或创办企业，并且与三一集团有限公司的下属公司存在业务交易，或与三一集团经营的业务存在竞争关系</span>？（公开市场上的股票、基金、债券及其衍生品投资，以及房产投资除外）',
			sbItemTitle3:'任职与兼职',
			sbItemQuest3:'3、您或您的直系亲属是否<span class="font_bold">在供应商、客户、代理商、竞争方任职、兼职</span>（包括以咨询、顾问或<span class="color_red">名誉职务等</span>其他类似身份从事的活动，不包括证书挂靠形式）。',
			sbItemTitle4:'经济往来',
			sbItemQuest4:'4、您或您的直系亲属是否与您职权范围内的业务往来个人或单位（不包括银行机构）存在借款、贷款、<span class="color_red">融资担保或商业交易（含赊销、分期付款等非即时结清交易）</span>或商务买卖行为？',
			sbItemTitle5:'职务便利',
			sbItemQuest5:'5、您是否<span class="font_bold">利用自身职权范围影响力或管辖公司资源</span>，帮助个人及其亲属、同学、朋友等获取利益或相应的机会。（如商务人员介绍亲朋在自己管辖的供应商处任职，公司领导干部安排亲朋在自己手下任职等）',
			sbItemTitle6:'亲属关系',
			sbItemQuest6:'6、在您入职前或入职后，您是否有以下亲属在公司任职？<br/><br/>包括：您配偶、您及配偶的父母、子女（及其配偶及配偶的父母）、祖父母/外祖父母；外甥/外甥女（及其配偶）；继父母、继子女（及其配偶及配偶的父母）；养父母、养子女（及其配偶及配偶的父母）；您及配偶的兄弟姐妹（及其配偶）；伯父/伯母；叔叔/婶婶；姑父/姑母；堂兄弟姐妹（及其配偶）；舅父/舅母；姨父/姨母；表兄弟姐妹（及其配偶）；侄子侄女（及其配偶）。',
			sbItemTitle7:'保密与竞业协议',
			sbItemQuest7:'7、您是否在入职本公司之前与原用人单位签订了<span class="font_bold">技术保密或竞业限制协议</span>，并且该协议目前仍在有效期内？',
			sbItemTitle8:'介绍业务',
			sbItemQuest8:'8、您作为董事、关键岗位或核心岗位的人员，或您的关系人（包括亲友、同学、老乡）是否曾介绍供应商与三一公司开展业务？（包括基建施工、采购、外协、零部件加工，<span class="color_red">包括提供供应商推荐、参与供应商资质审核等环节）</span>',
			sbItemTitle9:'其他',
			sbItemQuest9:'9、最近36个月内，您是否涉及<span class="font_bold">违反廉洁从业规定</span>的行为？（包括不限于吃拿卡要、弄虚作假、贪污受贿、挪用侵占、损害公司声誉、泄露公司秘密、串通投标、接受关联方宴请或礼金、其它舞弊行为）',

			qtxnr:'请填写{label}',
			qxznr:'请选择{label}',


			// tzxx:'投资信息',
			// qyxx:'企业信息',
			// br:'本人',
			// trmy:'他人名义',
			// xm:'姓名',
			// sjh:'手机号',
			// tzms:'投资模式',
			// zb:'占比',
			// qt:'其他',
			// ms:'描述',
			// bz:'备注',
			// qtxsbsxms:'请填写申报事项描述',
			// tjcg:'添加成功',
			// sccg:'删除成功',
			// gxrxx:'关系人信息',
			// gx:'关系',

			// br:'本人',
			// trmy:'他人名义',
			// ysyjtdgx:'与三一集团的关系',
			// tzlx:'投资类型',
			// dz:'独资',
			// hzhg:'合资/合股',
			// zc:'暂存',

			// jg:'警告',
			// rzgw:'任职岗位',
}

export default zh
